import { render, staticRenderFns } from "./addBatchCer.vue?vue&type=template&id=c98a6610&scoped=true&"
import script from "./addBatchCer.vue?vue&type=script&lang=js&"
export * from "./addBatchCer.vue?vue&type=script&lang=js&"
import style0 from "./addBatchCer.vue?vue&type=style&index=0&id=c98a6610&scoped=true&lang=css&"
import style1 from "./addBatchCer.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c98a6610",
  null
  
)

export default component.exports